import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import auth from './auth';
import config from './config';
import { apiAuth } from './auth/api';
import notice from './notice';
import { noticeMiddleware } from './notice/middleware';
import { apiBinance } from './binance/api';
import { apiPolymarket } from './polymarket/api'
import { apiPreopen } from './polymarket/preopen.api'
import { apiStats } from './polymarket/stats.api'

const store = configureStore({
  reducer: {
    [notice.name]: notice.reducer,
    [auth.name]: auth.reducer,
    [config.name]: config.reducer,
    [apiAuth.reducerPath]: apiAuth.reducer,
    [apiBinance.reducerPath]: apiBinance.reducer,
    [apiPolymarket.reducerPath]: apiPolymarket.reducer,
    [apiPreopen.reducerPath]: apiPreopen.reducer,
    [apiStats.reducerPath]: apiStats.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiAuth.middleware,
      apiBinance.middleware,
      apiPolymarket.middleware,
      apiPreopen.middleware,
      apiStats.middleware,
      noticeMiddleware
    ),
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
